/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import dayjs from 'dayjs';
import { Howl, Howler } from 'howler';
import { makeAutoObservable } from 'mobx';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';

import { exitGame } from '@/api/game';
import { removeGame } from '@/modules/play';
import { exitFullscreen, fullScreen } from '@/utils/fullscreen';
import Storage from '@/utils/Storage';
import { toast } from '@/utils/toast';

import globalStore from './store';

type gameMapProps = Record<
  string,
  {
    img: string;
    src: string;
    alone: boolean;
  }[]
>;

type gamesProps = {
  label: string;
  icon: React.ReactNode;
};

Howler.autoUnlock = true;
Howler.html5PoolSize = 100;
export const gameStore = makeAutoObservable({
  game: 'Hot',
  games: [] as gamesProps[],
  gameMap: {} as gameMapProps,
  loading: false, //展示动画

  /* 游戏音效 */
  soundMap: {},

  /** 游戏界面 */
  showGame: false,
  iframeRef: null,

  showLoading() {
    this.loading = true;
  },
  hideLoading() {
    this.loading = false;
  },

  loadSound() {
    const targetTime = '2024-12-26 00:00:00';
    const source: any = [
      {
        key: 'bg',
        src: window?.privateConfig?.noBgm
          ? []
          : [`${window.imgPrefix}/audio/${dayjs().isAfter(dayjs(targetTime)) ? 'bg.MP3' : 'christmas_bg.mp3'}`],
        volume: 0.5,
        onload: (sound: any) => {
          // sound.play();
        },
        onend: (sound: any) => {
          // console.log('bg sound ended', sound);
          // sound.load();
          sound.play();
        },
        onloaderror: (sound: any) => {
          // console.log('bg sound onloaderror', sound);
        },
        onplayerror: (sound: any) => {
          // console.log('bg sound onplayerror', sound);
        }
      },
      {
        key: 'btn',
        src: [`${window.imgPrefix}/audio/btn.MP3`],
        onend: (sound: any) => {
          // console.log('bg sound ended', sound);
        },
        onloaderror: (sound: any) => {
          // console.log('bg sound onloaderror', sound);
        },
        onplayerror: (sound: any) => {
          // console.log('bg sound onplayerror', sound);
        }
      },
      {
        key: 'collapse',
        src: [`${window.imgPrefix}/audio/collapse.MP3`]
      },
      {
        key: 'expand',
        src: [`${window.imgPrefix}/audio/expand.MP3`]
      }
    ];

    this.soundMap = source.reduce((acc, item) => {
      const sound = new Howl({
        src: item.src,
        loop: item.loop,
        volume: item.volume,
        html5: true,
        preload: true,
        xhr: {
          withCredentials: true
        },
        onload: () => {
          if (item?.onload) {
            item?.onload(sound);
          }
        },
        onend: () => {
          if (item?.onend) {
            item?.onend?.(sound);
          } else {
            sound.unload();
          }
        },
        onloaderror: () => {
          if (item?.onloaderror) {
            item?.onloaderror?.(sound);
          } else {
            sound.unload();
          }
        },
        onplayerror: () => {
          if (item?.onplayerror) {
            item?.onplayerror?.(sound);
          } else {
            sound.unload();
          }
        }
      });
      acc[item.key] = sound;
      return acc;
    }, {});
  },
  playSound(key: string) {
    const soundSaveState = Storage.getByUser('SOUND_STATE', true);
    if (!soundSaveState) {
      return;
    }
    if (window?.privateConfig?.noBgm) {
      return;
    }
    this.soundMap?.[key]?.play();
  },
  pauseSound(key: string) {
    if (window?.privateConfig?.noBgm) {
      return;
    }
    this.soundMap?.[key]?.pause();
  },
  stopSound(key: string) {
    if (window?.privateConfig?.noBgm) {
      return;
    }
    this.soundMap?.[key]?.stop();
  },
  isPlayingSound(key: string) {
    if (window?.privateConfig?.noBgm) {
      return false;
    }
    return this.soundMap?.[key]?.playing();
  },
  playBgm(key = 'bg') {
    const musicSaveState = Storage.getByUser('MUSIC_STATE', true);
    if (!musicSaveState) {
      return;
    }
    if (window?.privateConfig?.noBgm) {
      return;
    }
    this.soundMap?.[key]?.play();
  },
  pauseBgm(key = 'bg') {
    this.pauseSound(key);
  },
  stopBgm(key = 'bg') {
    this.stopSound(key);
  },
  isPlayingBgm(key = 'bg') {
    return this.isPlayingSound(key);
  },
  async setGames({ games, gameMap }: { games: gamesProps[]; gameMap: gameMapProps }) {
    if (!this.games.length) {
      this.games = games;
      this.gameMap = gameMap;
    }
  },

  async backGame(navigate: NavigateFunction) {
    this.showGame = true;
    navigate('/play');
  },
  hideGame() {
    this.showGame = false;
    exitFullscreen();
  },
  showGameF() {
    this.showGame = true;
  },
  async entryGame() {
    this.showGame = true;
  },
  async exitGame(data?: { msg: string; showMsgType?: 'toast' | 'alert'; score: number }) {
    if (data) {
      const { showMsgType, msg, score } = data;
      if (showMsgType === 'toast' && msg) {
        toast(msg, { id: 'toast-exitgame-msg' });
      }
      if (score) {
        globalStore.onGlobalStateChange?.({ score });
      }
    }

    await exitGame();
    // 删除iframe
    removeGame();
    this.showGame = false;
  }
});
